export const API_ENDPOINT = process.env.REACT_APP_API_KEY;

// Global
export const GET_ALL_CATEGORIES = "/global/category";
export const GET_SUB_CATEGORY = "/global/sub-category";
export const GET_ALL_PROMOCODES = "/global/promocodes";
export const GET_COUNTRY = "/global/country";
export const GET_STATE = "/global/state";
export const GET_CITY = "/global/city";
export const GET_PINCODE = "/global/pincode-details/";
export const PRODUCT_FILTERS = "/global/filter";
export const FILTER_ATTRIBUTES = "/global/get-attribute";
// export const S3_BUCKET = "https://ekartrent.s3.amazonaws.com";
export const S3_BUCKET = "https://draaxfiles.s3.us-west-2.amazonaws.com";
export const GLOBAL_PRODUCT = "/global/product"
export const GLOBAL_TOP_PRODUCT = "/global/top-product"
export const GLOBAL_PRODUCT_SUGGESTION = "/global/suggestion"
export const GlOBAL_COLLECTION = "/global/group"
export const GlOBAL_SUBSCRIBER = "/global/subscriber"
export const GLOBAL_BEST_SELLING = "/global/best-selling"


// User
export const PROMOCODE = '/user/promocode/'
export const CHANGE_PASSWORD = '/user/change-password'
export const GET_USER_DETAILS = '/user'
export const POST_CUSTOMER_SUPPORT = '/user/customer-support'
export  const ORDER_BY_ID  = '/user/order'
export  const ORDER_INVOICE  = '/user/invoice/'
export  const TICKET  = '/user/ticket'
export  const ADDRESS  = '/user/address'
export  const IMAGE_SELL  = '/image/user-sell'
export  const PRODUCT_RENT  = '/user/product-rent'
export const CANCEL_ORDER = '/user/order-item'
export const RETURN_PRODUCT = '/user/return-order'
export const SERVICE_REQUEST = '/user/service-request'
export const SERVICE_REQUEST_STATUS = '/user/service-request-status'
export const GUEST_LOGIN='/user/guest-login'
export const UPLOAD_CONTACTUS='/image/contact-us'
export const SUBMIT_CONTACTUS='/global/contact-us'